<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 text-center">
                <h2><i class="fas fa-users-cog"></i>&nbsp;&nbsp;Sales Connect Account</h2>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 text-center">
                <p>To enable menus, please connect your stripe account</p>
            </div>
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>
        
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">
            <img src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/banksalesconnect.png" class="logo-img"/>
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>
        
        <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="ActionBtnConnectedAccount == 'createAccount' || ActionBtnConnectedAccount == 'createAccountLink'">
            <base-button :class="statusColorConnectedAccount" :disabled="DisabledBtnConnectedAccount" size="sm" style="height:40px" id="btnCreateConnectedAccount" @click="processConnectedAccount();">
                <i class="fas fa-link"></i> <span v-html="txtStatusConnectedAccount"></span>
            </base-button>
            <div class="col-sm-12 col-md-12 col-lg-12 text-center pt-2 pb-2">OR</div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="(ActionBtnConnectedAccount == 'createAccount' || ActionBtnConnectedAccount == 'createAccountLink')">
            <base-button :class="statusColorConnectedAccount" :disabled="DisabledBtnConnectedAccount" size="sm" style="height:40px" id="btnExistsConnectedAccount" @click="processExsistingConnectedAccount();">
                <i class="fas fa-plug mr-1"></i> <span v-html="txtStatusConnectedExistingAccount"></span>
            </base-button>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="ActionBtnConnectedAccount == 'inverification' || ActionBtnConnectedAccount == 'accountConnected'">
            <h4 :style="{color:statusColorConnectedAccount}" v-html="txtStatusConnectedAccount"></h4>
        </div>

        <div class="pt-3 pb-3">&nbsp;</div>
        <div v-if="ActionBtnConnectedAccount === 'accountConnected'" style="max-width: 500px; margin: 0 auto; text-align: center;">
            <base-button v-if="refcode == ''" @click="createRefCode" style="margin-bottom: 16px;">Generate your referral</base-button>
            
            <p>
                <span style="display: inline-block; border-radius: 8px;">
                Referral Code: <strong>{{ refcode }}</strong>
                </span>
                <i class="el-icon-document-copy ml-2"
                @click="copyToClipboard(refcode)"
                style="font-size: 20px; color: #409eff; cursor: pointer;"></i>
            </p>

            <p style="margin-top: 20px; font-weight: 600;">🔗 Referral Link:</p>

            <p style="opacity: 0.9; word-break: break-all;">
                 {{ referralLink }}
                <i class="el-icon-document-copy ml-2" 
                @click="copyToClipboard(referralLink)"
                style="font-size: 20px; color: #409eff; cursor: pointer;"
                ></i>
            </p>
        </div>
    </div>
</template>

<script>
import { Message } from 'element-ui'

export default {
    data() {
        return {
            userData: '',

            txtStatusConnectedAccount: 'Setup your stripe account',
            txtStatusConnectedExistingAccount: 'Connect existing stripe account',
            ActionBtnConnectedAccount: '',
            DisabledBtnConnectedAccount: false,
            statusColorConnectedAccount: '',
            refreshURL: '/configuration/sales-connect-account/',
            returnURL: '/configuration/sales-connect-account/',
            accConID: '',
            rootdomainurl: '',
            refcode: '',
        }
    },
    computed: {
        referralLink() {
            return this.rootdomainurl + 'agency-register/' + this.refcode;
        }
    },
    methods: {
        createRefCode(){
            this.$store.dispatch('CreateRefLink', {
                userID: this.userData.id, 
            }).then(response => {
                if (response.result == 'success') {
                    this.refcode = response.refcode;
                    Message.success('Successfully generate refferal');
                    this.checkSalesConnectedAccount();
                }
            },error => {

            });
        },
        async copyToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text);
                    Message.success('Copied to clipboard!');
                } catch (err) {
                    Message.error("Failed to copy!");
                }
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    Message.success('Copied to clipboard!');
                } catch (err) {
                    Message.error("Failed to copy!");
                }
                document.body.removeChild(textArea);
            }
        },
        createConnectedAccountLink() {
            this.$store.dispatch('createConnectedAccountLink', {
                connectid: this.accConID,
                refreshurl: this.refreshURL,
                returnurl: this.returnURL,
                idsys: this.$global.idsys,
            }).then(response => {
                document.location = response.params.url;
            },error => {
                this.txtStatusConnectedAccount = "Setup your stripe account";
                this.DisabledBtnConnectedAccount = false;
                
                this.$notify({
                    type: 'warning',
                    message: 'we are unable to connect your account, please try again later or contact the support',
                    icon: 'tim-icons icon-bell-55'
                });  
            });
        },
        createConnectedAccount() {
            this.txtStatusConnectedAccount = "Connecting...";
            this.DisabledBtnConnectedAccount = true;

            this.$store.dispatch('createSalesConnectedAccount', {
                usrID: this.userData.id,
                idsys: this.$global.idsys,
            }).then(response => {
                this.accConID = response.params.ConnectAccID;
                this.createConnectedAccountLink();
            },error => {
                this.txtStatusConnectedAccount = "Setup your stripe account";
                this.DisabledBtnConnectedAccount = false;
                this.$notify({
                    type: 'warning',
                    message: 'we are unable to connect your account, with following message: ' + error,
                    icon: 'tim-icons icon-bell-55',
                    duration: 8000,
                });  

            });
        },
        processConnectedAccount() {
            if (this.ActionBtnConnectedAccount == 'createAccount') {
                this.createConnectedAccount();
            }else if (this.ActionBtnConnectedAccount == 'createAccountLink') {
                this.createConnectedAccountLink();
            }
        },
        checkSalesConnectedAccount() {
            this.$store.dispatch('checkSalesConnectedAccount', {
                usrID: this.userData.id,
                idsys: this.$global.idsys,
            }).then(response => {
                //console.log(response.googleSpreadsheetConnected);
                
                if (response.result == 'failed') {
                    this.txtStatusConnectedAccount = "Setup your stripe account";
                    this.ActionBtnConnectedAccount = 'createAccount';
                    this.statusColorConnectedAccount = '';
                }else if (response.result == 'pending') {
                    this.txtStatusConnectedAccount = 'Your stripe registration is incomplete, click here to continue';
                    this.ActionBtnConnectedAccount = 'createAccountLink';
                    this.accConID = response.params[0].acc_connect_id;
                    this.statusColorConnectedAccount = '';
                }else if (response.result == 'pending-verification' || response.result == 'inverification') {
                    this.txtStatusConnectedAccount = 'Almost there, stripe is verifying your account.';
                    this.ActionBtnConnectedAccount = 'inverification';
                    this.accConID = response.params[0].acc_connect_id;
                    this.statusColorConnectedAccount = '#fb6340';
                }else{
                    this.txtStatusConnectedAccount = "Stripe Account Connected"
                    this.ActionBtnConnectedAccount = 'accountConnected';
                    this.statusColorConnectedAccount = '#2dce89';
                    this.refcode = response.params[0].referralcode
                }


            },error => {
                
            });
        },
        processExsistingConnectedAccount() {
            this.txtStatusConnectedExistingAccount = 'Connecting...';
            this.DisabledBtnConnectedAccount = true;

            this
            .$store
            .dispatch('createExistingConnectedAccountLink', {
                company_root_id: this.$global.idsys,
                company_id: this.userData.company_id,
                email: this.userData.email,
                user_id: this.userData.id,
                user_type: this.userData.user_type,
                subdomain: window.location.href,
            })
            .then(response => {
                // console.log(response);
                if(response.url) {
                    document.location = response.url;
                } else {
                    this.$notify({ type: 'danger', message: 'url for setup stripe empty, please try again later or contact the support', icon: 'tim-icons icon-bell-55'});  
                }
            })
            .catch(error => {
                // console.error(error);
                this.txtStatusConnectedExistingAccount = 'Connect existing stripe account';
                this.DisabledBtnConnectedAccount = false;
                this.$notify({ type: 'danger', message: 'we are unable to connect your account, please try again later or contact the support', icon: 'tim-icons icon-bell-55'});  
            });
        }
    },
    mounted() {
        this.userData = this.$store.getters.userData;
        this.rootdomainurl = 'https://' + window.location.hostname + '/';

        /** FOR REFRESH URL CONNECTED STRIPE*/
        if (process.env.VUE_APP_DEVMODE == 'true') {
            // this.refreshURL = 'http://' + window.location.hostname + ':8080' +  this.refreshURL;
            // this.returnURL = 'http://' + window.location.hostname + ':8080' + this.returnURL;
            this.refreshURL = 'https://' + window.location.hostname +  this.refreshURL;
            this.returnURL = 'https://' + window.location.hostname + this.returnURL;
        }else{
            this.refreshURL = 'https://' + window.location.hostname  +  this.refreshURL;
            this.returnURL = 'https://' + window.location.hostname + this.returnURL;
        }
        /** FOR REFRESH URL CONNECTED STRIPE*/
        
        /** CHECK CONNECTED ACCOUNT */
        if (this.userData.user_type == 'sales') {
            this.checkSalesConnectedAccount();
        }
        /** CHECK CONNECTED ACCOUNT */
    }
}
</script>

<style>
    html.dark-theme .logo-img {
         filter: none;
    }

    html.light-theme .logo-img {
     filter: grayscale(100%) invert(100%);
    }
</style>
